import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './legal-terms.component.html',
  styleUrls: ['./legal-terms.component.css']
})
export class LegalTermsComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/legal-terms.component.ts